import React, { useEffect, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { useDispatch } from 'react-redux';

import { getSignRequirements } from '../../../services/docuSignService';

import { POPUP, MODAL } from '../../../../redux/types';

import { IDocuSignData } from '../../types/IDocuSignData';

import Main from '../../../layout/main/main';
import Icon from '../../../ui/icon/icon';

import '../../components/docuSign/docuSign.scss';

const DocuSignResponsive: React.FC = () => {
  const [signData, setSignData] = useState<any[]>([]);
  const [showDocuSign, setShowDocuSign] = useState<boolean>(true);

  const { t } = useTranslate();
  const dispatch = useDispatch();

  useEffect(() => {
    getSignRequirements().then((res: IDocuSignData[]) => {
      setSignData(res);
    }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  }, []);

  const goToDocuSign = (item: IDocuSignData): void => {
    dispatch({ type: MODAL.SWITCH_REDIRECTING_TO_DS_MODAL, payload: item });
  };

  const closeDocuSignInfo = (): void => {
    setShowDocuSign(false);
  };

  return (
    <Main title={t('DOCUSIGN_RESPONSIVE.PAGE_TITLE')}>
      <div style={{ paddingTop: 10 }}>
        {showDocuSign && signData &&
          signData.map((item, key) => {
            return (
              <div className='docusign-wrapper' style={{ marginBottom: 30 }}>
                <div className='docusign-left hidden-mobile'>
                  <span className='action-required-span'>{t('HOME.DOCUSIGN_ACTION_REQUIRED')}</span>
                </div>
                <div className='docusign-docs'>
                  {!item.isSigned && (
                    <div className='docusign-item-wrapper pointer' key={key} onClick={() => goToDocuSign(item)}>
                      <span>{item.name}</span>
                    </div>
                  )}
                </div>
                <div className='docusign-right'>
                  <Icon name='fas fa-arrow-alt-to-bottom' className='docusign-icon' />
                </div>
                <Icon name='fas fa-times-circle' className='close-circle-btn pointer' onClick={closeDocuSignInfo} />
              </div>
            );
          })
        }
      </div>
    </Main>
  );
};

export default DocuSignResponsive;